import { forEach, get, isEmpty, isNil, map } from 'lodash';
import turf from '@turf/turf';

import adaptURL from './adapt-url';

/**
 * Fetch the GeoJSON stored in the URL.
 *
 * @async
 * @param {string} url - The URL where the GeoJSON is stored.
 * @returns {Promise<object>} The geojson file stored in the URL.
 * @throws {Error} If something goes wrong.
 */
const loadGeoJSONIndoorFromURL = async url => {
  try {
    const response = await fetch(url);
    if (response.ok) {
      const mainGeoJSON = await response.json();
      if (isNil(mainGeoJSON)) throw new Error('Empty Response');

      const features = [];
      turf.featureEach(mainGeoJSON, feature => features.push(feature));

      const subGeoJSONPromises = [];
      turf.featureEach(mainGeoJSON, feature => {
        const featureURL = adaptURL(get(feature, 'properties.url', ''));
        if (!isEmpty(featureURL)) subGeoJSONPromises.push(fetch(featureURL));
      });
      const subGeoJSONResponses = await Promise.all(subGeoJSONPromises);
      const subGeoJSONs = await Promise.all(
        map(subGeoJSONResponses, subGeoJSONResponse => subGeoJSONResponse.json())
      );

      forEach(subGeoJSONs, subGeoJSON => {
        turf.featureEach(subGeoJSON, feature => features.push(feature));
      });

      return turf.featureCollection(features);
    }
    console.error(response);
    throw new Error('Network response was not ok. Server Error');
  } catch (err) {
    throw new Error(err.message);
  }
};

export default loadGeoJSONIndoorFromURL;
